module.exports = __webpack_public_path__ + "img/uploadicon.7d247160.svg";